export class ModalErrorArgs {
    Message: string;
    Title: string;

    constructor(message: string, title: string) {
        this.Message = message;
        this.Title = title;
    }
}


// WEBPACK FOOTER //
// ./src/app/modals/modal-error-args.ts